import {api} from './ApiService';

export default class PackageService {
    
    static async search(key,page,perpage){
        let data ={
            searchKey: key,
            page: page,
            perpage:perpage
        }
        
        let response =  await api.post(`/package/search`,data)
        return response.data
    }
    static async searchName(key){
        let data ={
            searchKey: key
        }
        let response =  await api.post(`/package/search/name`,data)
        return response.data
    }

    static async searchList(key,page,perpage){
        let data ={
            searchKey: key,
            page: page,
            perpage:perpage
        }
        let response =  await api.post(`/package/search/list`,data)
        return response.data
    }
 
    static async create(data){
        let response = await api.post(`/package/create`,data)
        return response.data
    }
    static async update(data){
        let response = await api.post(`/package/update`,data)
        return response.data
    }
    static async delete(id){
        let response = await api.post(`/package/delete`,{package_id:id})
        return response.data
    }
    
}


// WEBPACK FOOTER //
// ./src/service/PackageService.js